import { experienceBuilderApi } from 'api'

export const fetchSkillById = (skillId: string) =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/skills/' + skillId)
